export default __webpack_public_path__ + "static/joakim-c91c23f967c3bbec2e5b9596a4e0cad3.png";